import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  faqs: [
    {
      id: 1,
      category: 'Inscription & Connexion',
      question: 'Comment créer un compte professionnel ?',
      answer: 'Cliquez sur "Inscription", choisissez "Je suis un professionnel" et remplissez vos informations de base : nom, prénom, email, mot de passe et spécialité sportive. Vous recevrez un email de confirmation pour activer votre compte.'
    },
    {
      id: 2,
      category: 'Inscription & Connexion',
      question: 'Comment créer un compte organisation ?',
      answer: 'Cliquez sur "Inscription", sélectionnez "Je représente une organisation" et complétez les informations : nom de l\'organisation, secteur d\'activité, adresse et informations de contact. Votre compte sera vérifié sous 24h.'
    },
    {
      id: 3,
      category: 'Inscription & Connexion',
      question: 'J\'ai oublié mon mot de passe, que faire ?',
      answer: 'Sur la page de connexion, cliquez sur "Mot de passe oublié", saisissez votre email et suivez les instructions reçues par email pour réinitialiser votre mot de passe.'
    },
    {
      id: 4,
      category: 'Missions & Postulations',
      question: 'Comment une organisation peut publier une mission ?',
      answer: 'Connectez-vous à votre compte organisation, allez dans "Tableau de bord" > "Nouvelle mission", remplissez le formulaire avec les détails de la mission (titre, description, compétences requises, budget, dates) et publiez.'
    },
    {
      id: 5,
      category: 'Missions & Postulations',
      question: 'Comment postuler à une mission en tant que professionnel ?',
      answer: 'Parcourez les missions disponibles, cliquez sur celle qui vous intéresse, lisez attentivement les détails et cliquez sur "Postuler". Rédigez une lettre de motivation personnalisée et soumettez votre candidature.'
    },
    {
      id: 6,
      category: 'Missions & Postulations',
      question: 'Puis-je modifier ma candidature après l\'avoir envoyée ?',
      answer: 'Vous pouvez modifier votre candidature tant que l\'organisation ne l\'a pas encore examinée. Rendez-vous dans "Mes candidatures" pour apporter des modifications.'
    },
    {
      id: 7,
      category: 'Paiements & Facturation',
      question: 'Comment fonctionne le système de paiement ?',
      answer: 'Les paiements sont sécurisés via notre plateforme. L\'organisation paie à la fin de la mission, Mission Sport prélève sa commission de 20% et verse le reste au professionnel sous 48h.'
    },
    {
      id: 8,
      category: 'Paiements & Facturation',
      question: 'Quand suis-je payé pour une mission ?',
      answer: 'Le paiement est effectué dans les 48h suivant la validation de la mission par l\'organisation. Vous recevrez une notification par email et pourrez suivre le statut dans votre tableau de bord.'
    },
    {
      id: 9,
      category: 'Paiements & Facturation',
      question: 'Quelle est la commission de Mission Sport ?',
      answer: 'Mission Sport prélève une commission de 20% sur chaque mission pour maintenir la plateforme, assurer le support client et garantir la sécurité des transactions.'
    },
    {
      id: 10,
      category: 'Profils & Certifications',
      question: 'Comment compléter mon profil professionnel ?',
      answer: 'Allez dans "Mon profil", ajoutez vos certifications, expériences, photos et descriptions détaillées de vos compétences. Un profil complet augmente vos chances d\'être sélectionné.'
    },
    {
      id: 11,
      category: 'Profils & Certifications',
      question: 'Mes certifications sont-elles vérifiées ?',
      answer: 'Oui, notre équipe vérifie les certifications importantes. Téléchargez vos diplômes et certificats en format PDF pour accélérer le processus de vérification.'
    },
    {
      id: 12,
      category: 'Sécurité & Modération',
      question: 'Comment signaler un comportement inapproprié ?',
      answer: 'Utilisez le bouton "Signaler" présent sur chaque profil ou mission, ou contactez directement notre support. Nous prenons tous les signalements au sérieux et agissons rapidement.'
    },
    {
      id: 13,
      category: 'Sécurité & Modération',
      question: 'Mes données personnelles sont-elles protégées ?',
      answer: 'Absolument. Nous respectons le RGPD et utilisons un chiffrement SSL pour protéger vos données. Consultez notre politique de confidentialité pour plus de détails.'
    }
  ],
  tutorials: [
    {
      id: 1,
      title: 'Créer mon premier profil',
      description: 'Guide complet pour créer un profil attractif',
      icon: 'user',
      slug: 'creer-profil'
    },
    {
      id: 2,
      title: 'Publier une mission',
      description: 'Comment rédiger et publier une mission efficace',
      icon: 'briefcase',
      slug: 'publier-mission'
    },
    {
      id: 3,
      title: 'Contacter un professionnel',
      description: 'Meilleures pratiques pour communiquer',
      icon: 'message',
      slug: 'contacter-professionnel'
    },
    {
      id: 4,
      title: 'Gérer mes paiements',
      description: 'Comprendre le système de facturation',
      icon: 'credit-card',
      slug: 'gerer-paiements'
    }
  ],
  searchQuery: '',
  filteredFaqs: [],
  supportForm: {
    loading: false,
    success: false,
    error: null
  }
};

const helpSlice = createSlice({
  name: 'help',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      if (action.payload.trim() === '') {
        state.filteredFaqs = [];
      } else {
        const query = action.payload.toLowerCase();
        state.filteredFaqs = state.faqs.filter(
          faq => 
            faq.question.toLowerCase().includes(query) ||
            faq.answer.toLowerCase().includes(query) ||
            faq.category.toLowerCase().includes(query)
        );
      }
    },
    clearSearch: (state) => {
      state.searchQuery = '';
      state.filteredFaqs = [];
    },
    submitSupportFormStart: (state) => {
      state.supportForm.loading = true;
      state.supportForm.error = null;
      state.supportForm.success = false;
    },
    submitSupportFormSuccess: (state) => {
      state.supportForm.loading = false;
      state.supportForm.success = true;
    },
    submitSupportFormFailure: (state, action) => {
      state.supportForm.loading = false;
      state.supportForm.error = action.payload;
    },
    clearSupportForm: (state) => {
      state.supportForm.loading = false;
      state.supportForm.success = false;
      state.supportForm.error = null;
    }
  }
});

export const {
  setSearchQuery,
  clearSearch,
  submitSupportFormStart,
  submitSupportFormSuccess,
  submitSupportFormFailure,
  clearSupportForm
} = helpSlice.actions;

export default helpSlice.reducer;